import { useEffect, useRef } from "react";
import keycloak from "./keycloak";
import { showToast } from "./utils/toastManager";

const INACTIVITY_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
  "click",
];

export default function useInactivityLogout(isAuthenticated) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    function logout() {
      showToast("You've been logged out due to inactivity.", "warning");

      // Clear keycloak callback state before logout
      Object.keys(localStorage)
        .filter((k) => k.startsWith("kc-callback-"))
        .forEach((k) => localStorage.removeItem(k));

      try {
        keycloak.logout({
          redirectUri: window.location.origin + "/ProviderSearchPage",
        });
      } catch {
        window.location.href = "/ProviderSearchPage";
      }
    }

    function resetTimer() {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(logout, INACTIVITY_TIMEOUT_MS);
    }

    // Start the timer immediately
    resetTimer();

    // Debounce activity events so we don't reset on every pixel of mouse movement
    let debounceTimer = null;
    function onActivity() {
      if (debounceTimer) return;
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
      }, 1000);
      resetTimer();
    }

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, onActivity, { passive: true }),
    );

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (debounceTimer) clearTimeout(debounceTimer);
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, onActivity),
      );
    };
  }, [isAuthenticated]);
}
